import {createFileRoute, Navigate} from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/orders/_layout/')({
	component: RouteComponent,
})


function RouteComponent() {
	return <Navigate to={"/orders/new"} />
}
